import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: 'e4c5d078-d823-4232-aba9-6eb1e4e5297d',
    countryCodes: ['CH'],
    locale: 'de-CH',
    languages: [
        {
            countryCode: 'DE',
            url: 'https://www.zalando-lounge.ch',
            active: true,
        },
        {
            countryCode: 'FR',
            url: 'https://fr.zalando-lounge.ch',
            active: false,
        },
    ],
});
